<template>
  <div class="address">
    <div class="top">
      <headline-view v-bind:title="title" />
    </div>
    <div class="address-container">
      <div v-if="countriesLoaded" class="input-container">
        <span class="headline">Customer type: *</span>
        <select
          v-model="customerData.customerType"
          v-on:change="updateCustomerType"
          v-bind:style="{ 'border-color': this.customerTypeValid }"
          class="select"
          type="text"
          v-bind:disabled="
            this.$router.currentRoute.name.includes('subscription')
          "
        >
          <option disabled value="" selected>Please select</option>
          <option value="1">End customer (private person)</option>
          <option value="2">Business customer (B2B company)</option>
        </select>
      </div>

      <span v-if="this.$store.state.customerData.customerType != null">
        <div class="input-container">
          <span class="headline">E-Mail (for invoice receipt): *</span>
          <input
            v-model="customerData.email"
            v-bind:style="{ 'border-color': this.$store.state.emailValid }"
            v-on:input="updateEmail"
            class="input"
            type="text"
          />
        </div>

        <div class="input-container-row">
          <div class="input-container firstname">
            <span class="headline">First name: *</span>
            <input
              v-model="customerData.firstname"
              v-bind:style="{
                'border-color': this.$store.state.firstnameValid,
              }"
              v-on:input="updateFirstname"
              class="input"
              type="text"
            />
          </div>
          <div class="input-container lastname">
            <span class="headline">Second name: *</span>
            <input
              v-model="customerData.secondname"
              v-bind:style="{
                'border-color': this.$store.state.secondnameValid,
              }"
              v-on:input="updateSecondname"
              class="input"
              type="text"
            />
          </div>
        </div>
        <div v-if="customerData.customerType != 1" class="input-container">
          <span class="headline">Company name / Organisation: *</span>
          <input
            v-model="customerData.company"
            v-bind:style="{ 'border-color': this.$store.state.companyValid }"
            v-on:input="updateCompany"
            class="input"
            type="text"
          />
        </div>

        <div class="input-container-row">
          <div class="input-container street">
            <span class="headline">Street: *</span>
            <input
              v-model="customerData.street"
              v-bind:style="{ 'border-color': this.$store.state.streetValid }"
              v-on:input="updateStreet"
              class="input"
              type="text"
            />
          </div>
          <div class="input-container house-number">
            <span class="headline">House number: *</span>
            <input
              v-model="customerData.houseNumber"
              v-bind:style="{
                'border-color': this.$store.state.houseNumberValid,
              }"
              v-on:input="updateHouseNumber"
              class="input"
              type="text"
            />
          </div>
        </div>

        <div class="input-container-row">
          <div class="input-container zip">
            <span class="headline">ZIP: *</span>
            <input
              v-model="customerData.zip"
              v-bind:style="{ 'border-color': this.$store.state.zipValid }"
              v-on:input="updateZip"
              class="input"
              type="text"
            />
          </div>
          <div class="input-container city">
            <span class="headline">City: *</span>
            <input
              v-model="customerData.city"
              v-bind:style="{ 'border-color': this.$store.state.cityValid }"
              v-on:input="updateCity"
              class="input"
              type="text"
            />
          </div>
        </div>

        <div v-if="countriesLoaded" class="input-container">
          <span class="headline">Country: *</span>
          <select
            v-model="customerData.country"
            v-on:change="updateCountry"
            class="select"
            type="text"
            v-bind:style="{ 'border-color': this.countryValid }"
          >
            <option disabled value="" selected>Please select</option>
            <option
              v-for="(value, key) in countries"
              v-bind:key="key"
              v-bind:value="value.id"
              >{{ value.country_name }}</option
            >
          </select>
        </div>
        <div
          class="input-container-row"
          v-if="this.$router.currentRoute.name == 'checkout'"
        >
          <div class="input-container privacy-policy">
            <span
              class="checkbox-container"
              v-bind:style="{
                border: '1px solid ' + this.$store.state.privacyPolicyValid,
              }"
            >
              <input
                v-model="customerData.privacyPolicy"
                v-on:input="updatePrivacyPolicy"
                class="input"
                type="checkbox"
              />
            </span>
            <div class="check-text">
              <span class="space">I agree to</span>
              <a
                target="_blank"
                href="https://www.solar-fox.com/en/data-privacy.html"
              >
                Privacy Policy
              </a>
              <span>: *</span>
            </div>
          </div>
          <div class="input-container terms-conditions">
            <span
              class="checkbox-container"
              v-bind:style="{
                border: '1px solid ' + this.$store.state.termsConditionsValid,
              }"
            >
              <input
                v-model="customerData.termsConditions"
                v-on:input="updateTermsConditions"
                class="input"
                type="checkbox"
              />
            </span>
            <div class="check-text">
              <span class="space">I agree to the</span>
              <a
                target="_blank"
                href="https://www.solar-fox.com/en/terms-of-use.html"
              >
                General terms and conditions and terms of services
              </a>
              <span>: *</span>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import HeadlineView from "@/components/Checkout/Headline.vue";

export default {
  name: "address-view",
  data() {
    return {
      title: "Billing Address",
      countriesLoaded: false,
      customerTypeValid: "#e7e7e7",
      countryValid: "#e7e7e7",
      customerData: {
        customerType: "",
        email: "",
        firstname: "",
        secondname: "",
        company: "",
        street: "",
        houseNumber: "",
        zip: "",
        city: "",
        country: "",
        privacyPolicy: false,
        termsConditions: false,
      },
    };
  },
  props: {},
  components: {
    "headline-view": HeadlineView,
  },
  computed: {
    countries() {
      return this.$store.state.countries;
    },
  },
  async mounted() {
    await this.$store.dispatch("getCountries");
    this.countriesLoaded = true;
    // this.$store.commit("assignCustomerType", 2);
    // this.$store.commit("assignCountry", 57);
    // this.$store.commit("assignEmail", "m.nagel@solar-fox.com");
    // this.$store.commit("assignFirstname", "Marius");
    // this.$store.commit("assignSecondname", "Nagel");
    // this.$store.commit("assignCompany", "Spirit Solar Limited");
    // this.$store.commit("assignStreet", "Portman Road");
    // this.$store.commit("assignZip", "RG30 1EA");
    // this.$store.commit("assignCity", "Reading");
    // this.$store.commit("assignHouseNumber", "44");
    if (this.$router.currentRoute.name.includes("subscription")) {
      await this.$store.dispatch("getSubscriptionCustomer");
      this.customerData.customerType = this.$store.state.customerData.customerType;
      this.customerData.email = this.$store.state.customerData.email;
      this.customerData.firstname = this.$store.state.customerData.firstname;
      this.customerData.secondname = this.$store.state.customerData.secondname;
      this.customerData.company = this.$store.state.customerData.company;
      this.customerData.street = this.$store.state.customerData.street;
      this.customerData.houseNumber = this.$store.state.customerData.houseNumber;
      this.customerData.zip = this.$store.state.customerData.zip;
      this.customerData.city = this.$store.state.customerData.city;
      this.customerData.country = this.$store.state.customerData.country;
    }
  },
  methods: {
    updateEmail(e) {
      this.$store.commit("assignEmail", e.target.value);
      if (e.target.value != "") this.$store.commit("assignEmailValid", "green");
      if (e.target.value == "")
        this.$store.commit("assignEmailValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.email = this.$store.state.customerData.email;
    },
    updateFirstname(e) {
      this.$store.commit("assignFirstname", e.target.value);
      if (e.target.value != "")
        this.$store.commit("assignFirstnameValid", "green");
      if (e.target.value == "")
        this.$store.commit("assignFirstnameValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.firstname = this.$store.state.customerData.firstname;
    },
    updateSecondname(e) {
      this.$store.commit("assignSecondname", e.target.value);
      if (e.target.value != "")
        this.$store.commit("assignSecondnameValid", "green");
      if (e.target.value == "")
        this.$store.commit("assignSecondnameValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.secondname = this.$store.state.customerData.secondname;
    },
    async updateCompany(e) {
      await this.$store.commit("assignVatCheckSuccessfull", false);
      this.$store.commit("assignCompany", e.target.value);
      if (e.target.value != "")
        this.$store.commit("assignCompanyValid", "green");
      if (e.target.value == "")
        this.$store.commit("assignCompanyValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.company = this.$store.state.customerData.company;
    },
    async updateStreet(e) {
      await this.$store.commit("assignVatCheckSuccessfull", false);
      this.$store.commit("assignStreet", e.target.value);
      if (e.target.value != "")
        this.$store.commit("assignStreetValid", "green");
      if (e.target.value == "")
        this.$store.commit("assignStreetValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.street = this.$store.state.customerData.street;
    },
    async updateHouseNumber(e) {
      await this.$store.commit("assignVatCheckSuccessfull", false);
      this.$store.commit("assignHouseNumber", e.target.value);
      if (e.target.value != "")
        this.$store.commit("assignHouseNumberValid", "green");
      if (e.target.value == "")
        this.$store.commit("assignHouseNumberValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.houseNumber = this.$store.state.customerData.houseNumber;
    },
    async updateZip(e) {
      await this.$store.commit("assignVatCheckSuccessfull", false);
      this.$store.commit("assignZip", e.target.value);
      if (e.target.value != "") this.$store.commit("assignZipValid", "green");
      if (e.target.value == "") this.$store.commit("assignZipValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.zip = this.$store.state.customerData.zip;
    },
    async updateCity(e) {
      await this.$store.commit("assignVatCheckSuccessfull", false);
      this.$store.commit("assignCity", e.target.value);
      if (e.target.value != "") this.$store.commit("assignCityValid", "green");
      if (e.target.value == "")
        this.$store.commit("assignCityValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.city = this.$store.state.customerData.city;
    },
    async updateCountry(e) {
      await this.$store.commit("assignCountry", null);
      await this.$store.commit("assignCountry", e.target.value);
      if (e.target.value != "") this.countryValid = "green";
      if (e.target.value == "") this.countryValid = "#e7e7e7";
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.country = this.$store.state.customerData.country;
    },
    async updateCustomerType(e) {
      await this.$store.commit("assignCustomerType", null);
      await this.$store.commit("assignVatCheckSuccessfull", false);
      await this.$store.commit("assignVatId", "");
      await this.$store.commit("assignCustomerType", e.target.value);
      if (e.target.value != "") this.customerTypeValid = "green";
      if (e.target.value == "") this.customerTypeValid = "#e7e7e7";
      // TODO: HEEELP CLEAN ME, props to Josh
      console.log(e.target.value)
      this.customerData.customerType = this.$store.state.customerData.customerType;
    },
    async updatePrivacyPolicy(e) {
      await this.$store.commit("assignPrivacyPolicy", e.target.checked);
      if (e.target.checked)
        this.$store.commit("assignPrivacyPolicyValid", "green");
      if (!e.target.checked)
        this.$store.commit("assignPrivacyPolicyValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.privacyPolicy = this.$store.state.customerData.privacyPolicy;
    },
    async updateTermsConditions(e) {
      await this.$store.commit("assignTermsConditions", e.target.checked);
      if (e.target.checked)
        this.$store.commit("assignTermsConditionsValid", "green");
      if (!e.target.checked)
        this.$store.commit("assignTermsConditionsValid", "#e7e7e7");
      // TODO: HEEELP CLEAN ME, props to Josh
      this.customerData.termsConditions = this.$store.state.customerData.termsConditions;
    },
  },
};
</script>

<style scoped>
.address {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.address-container {
  height: 85%;
  width: 100%;
  display: flex;
  border-radius: 6px;
  flex-direction: column;
}

.address .top {
  display: flex;
  width: 100%;
  height: 15%;
}

.street {
  width: 79%;
  margin-right: 1%;
}

.house-number {
  width: 20%;
}

.firstname {
  width: 49.5%;
  margin-right: 0.5%;
}
.lastname {
  width: 49.5%;
  margin-left: 0.5%;
}
.city {
  width: 79%;
  margin-left: 1%;
}
.zip {
  width: 20%;
}
.privacy-policy .checkbox-container {
  border-radius: 4px;
  margin-right: 15px;
}
.privacy-policy {
  align-items: center;
  width: 35%;
  flex-direction: row;
}
.privacy-policy input {
  height: 20px;
  width: 20px;
  margin: 0;
}
.terms-conditions .checkbox-container {
  border-radius: 4px;
  margin-right: 15px;
}
.terms-conditions {
  align-items: center;
  width: 65%;
  flex-direction: row;
}
.check-text {
  font-size: 11px;
}
.terms-conditions input {
  height: 20px;
  width: 20px;
  margin: 0;
}
.space {
  margin-right: 3px;
}
.input-container a {
  color: #888888;
}
</style>
